"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4941],{

/***/ 77954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52737);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53893);
/* harmony import */ var app_constants_enums__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57628);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  padding: 20px 20px 0;\n  .title {\n    font-size: 16px;\n    font-weight: bold;\n    margin: 0;\n  }\n  .expand-more {\n    border: none;\n    background: none;\n    padding: 0px;\n    font-size: 12px;\n    font-weight: 500;\n    svg {\n      width: 10px;\n      height: 10px;\n      transform: translateY(0.5px);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var BestStoryHeader = function(param) {
    var type = param.type, isExpandBtn = param.isExpandBtn;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,context__WEBPACK_IMPORTED_MODULE_3__/* .useDomain */ .ay)(), protocol = ref.protocol, xen = ref.xen, academyCommunityBaseUrl = ref.academyCommunityBaseUrl;
    var handleClickExpand = function() {
        if (type === app_constants_enums__WEBPACK_IMPORTED_MODULE_6__/* .BestStoryType.COMMUNITY */ .k.COMMUNITY) {
            window.location.href = "".concat(protocol, "://").concat(xen, "/best");
        } else if (type === app_constants_enums__WEBPACK_IMPORTED_MODULE_6__/* .BestStoryType.CBT_COMMUNITY */ .k.CBT_COMMUNITY) {
            window.location.href = "".concat(academyCommunityBaseUrl, "/cbt-best");
        } else if (type === app_constants_enums__WEBPACK_IMPORTED_MODULE_6__/* .BestStoryType.CHANNEL */ .k.CHANNEL) {
            router.push({
                pathname: "/channel",
                query: {
                    tab: "home",
                    "order-by": "popular"
                }
            });
        }
    };
    var BestTitle = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (type === app_constants_enums__WEBPACK_IMPORTED_MODULE_6__/* .BestStoryType.COMMUNITY */ .k.COMMUNITY) return "커뮤니티 BEST 소식";
        if (type === app_constants_enums__WEBPACK_IMPORTED_MODULE_6__/* .BestStoryType.CBT_COMMUNITY */ .k.CBT_COMMUNITY) return "시험정보방 BEST 소식";
        if (type === app_constants_enums__WEBPACK_IMPORTED_MODULE_6__/* .BestStoryType.CHANNEL */ .k.CHANNEL) return "기업채널 BEST 소식";
        return "링커리어 BEST 이야기";
    }, [
        type
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "title",
                children: BestTitle
            }),
            isExpandBtn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                className: "expand-more",
                onClick: handleClickExpand,
                children: [
                    "더보기",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_5__/* .ArrowRight */ .ol, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BestStoryHeader);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "BestStoryHeader__StyledWrapper",
    componentId: "sc-9a1be34-0"
})(_templateObject());


/***/ }),

/***/ 51943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BestStory_BestStoryList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
;// CONCATENATED MODULE: ./src/app.components/BestStory/BestStoryEmpty.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-items: center;\n  padding: 115px 0;\n  font-size: 14px;\n  color: #777;\n  img {\n    width: 67px;\n    height: 50px;\n    margin-bottom: 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BestStoryEmpty = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/static/images/channel/recruit.png",
                alt: "enterprise"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "베스트 소식이 없습니다."
            })
        ]
    });
};
/* harmony default export */ var BestStory_BestStoryEmpty = (BestStoryEmpty);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BestStoryEmpty__StyledWrapper",
    componentId: "sc-c13b7945-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.components/BestStory/BestStoryLoading.tsx

function BestStoryLoading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px 0;\n  gap: 10px;\n  .loading {\n    background-color: #eee;\n    border-radius: 5px;\n    height: 14px;\n  }\n"
    ]);
    BestStoryLoading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BestStoryLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BestStoryLoading_StyledWrapper, {
        children: new Array(10).fill("").map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading"
            }, index);
        })
    });
};
/* harmony default export */ var BestStory_BestStoryLoading = (BestStoryLoading);
var BestStoryLoading_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BestStoryLoading__StyledWrapper",
    componentId: "sc-fb25b0d3-0"
})(BestStoryLoading_templateObject());

;// CONCATENATED MODULE: ./src/app.components/BestStory/BestStoryList.tsx

function BestStoryList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 20px;\n  .item {\n    display: flex;\n    font-size: 14px;\n    .lt {\n      font-weight: bold;\n      padding-right: 7px;\n    }\n    .rt {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n    .comment-count {\n      color: #ef2929;\n      padding-left: 2px;\n    }\n  }\n"
    ]);
    BestStoryList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var BestStoryList = function(param) {
    var data = param.data, loading = param.loading;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(BestStory_BestStoryLoading, {});
    if (!loading && !data.length) return /*#__PURE__*/ (0,jsx_runtime.jsx)(BestStory_BestStoryEmpty, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BestStoryList_StyledWrapper, {
        children: data.map(function(item, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: item.href,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "item",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lt",
                            children: "".concat(idx + 1).padStart(2, "0")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "rt",
                            children: item.content
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "comment-count",
                            children: [
                                "(",
                                item.commentCount,
                                ")"
                            ]
                        })
                    ]
                })
            }, idx);
        })
    });
};
/* harmony default export */ var BestStory_BestStoryList = (BestStoryList);
var BestStoryList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BestStoryList__StyledWrapper",
    componentId: "sc-4afd74a4-0"
})(BestStoryList_templateObject());


/***/ }),

/***/ 31730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ app_components_BestStory; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.constants/enums.ts
var enums = __webpack_require__(57628);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context.ts + 1 modules
var context = __webpack_require__(52737);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.feed/module/ReplaceStrToDots.ts
var ReplaceStrToDots = __webpack_require__(49045);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/app.components/BestStory/BestStoryList.tsx + 2 modules
var BestStoryList = __webpack_require__(51943);
;// CONCATENATED MODULE: ./src/app.components/BestStory/BestStoryAll/channelBestStory/ChannelBestPost.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query gqlChannelBestNews($pagination: Pagination, $type: BestNewsItemType) {\n    bestNewsItems(pagination: $pagination, type: $type) {\n      nodes {\n        id\n        content\n        newsCommentCount\n        channel {\n          id\n          url\n          name\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px 20px 0px;\n  .tab-box {\n    display: flex;\n    gap: 16px;\n    .tab {\n      cursor: pointer;\n      border: none;\n      padding: 0px;\n      background: none;\n      font-size: 14px;\n      font-weight: 500;\n      color: #666;\n      &[data-active='true'] {\n        color: #01a0ff;\n        font-weight: bold;\n      }\n      :hover {\n        color: #01a0ff;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









src_default()(_templateObject());
var ChannelBestPost = function() {
    var isWebview = (0,useIsWebview/* default */.Z)();
    var ref = (0,react.useState)(graphql/* BestNewsItemType.RECENT */.qkq.RECENT), currentTab = ref[0], setCurrentTab = ref[1];
    var ref1 = (0,graphql/* useGqlChannelBestNewsQuery */._cZ)({
        variables: {
            pagination: {
                page: 1,
                pageSize: 10
            },
            type: currentTab
        }
    }), data = ref1.data, loading = ref1.loading;
    var channelBestTabs = (0,react.useMemo)(function() {
        return [
            {
                label: "실시간",
                active: currentTab === graphql/* BestNewsItemType.RECENT */.qkq.RECENT,
                onClick: function() {
                    return setCurrentTab(graphql/* BestNewsItemType.RECENT */.qkq.RECENT);
                }
            },
            {
                label: "댓글순",
                active: currentTab === graphql/* BestNewsItemType.COMMENT */.qkq.COMMENT,
                onClick: function() {
                    return setCurrentTab(graphql/* BestNewsItemType.COMMENT */.qkq.COMMENT);
                }
            },
            {
                label: "스크랩순",
                active: currentTab === graphql/* BestNewsItemType.SCRAP */.qkq.SCRAP,
                onClick: function() {
                    return setCurrentTab(graphql/* BestNewsItemType.SCRAP */.qkq.SCRAP);
                }
            },
            {
                label: "좋아요순",
                active: currentTab === graphql/* BestNewsItemType.LIKE */.qkq.LIKE,
                onClick: function() {
                    return setCurrentTab(graphql/* BestNewsItemType.LIKE */.qkq.LIKE);
                }
            }, 
        ];
    }, [
        currentTab
    ]);
    var dataSet = (0,react.useMemo)(function() {
        var ref;
        var result = (data === null || data === void 0 ? void 0 : (ref = data.bestNewsItems) === null || ref === void 0 ? void 0 : ref.nodes.map(function(newsItem) {
            var ref, ref1, ref2;
            var channelNameEllipsis = (0,ReplaceStrToDots/* replaceStrToDots */.Z)((newsItem === null || newsItem === void 0 ? void 0 : (ref = newsItem.channel) === null || ref === void 0 ? void 0 : ref.name) || "", 4);
            // html 태그 제거 정규식
            var htmlTagRegex = /<[^>]*>?/g;
            var escapedHtmlTag = (newsItem === null || newsItem === void 0 ? void 0 : newsItem.content.replace(htmlTagRegex, "")) || "";
            // "새로운 공고가 등록되었습니다.", "공고제목 :", "모집기간 :", "상세url :"이 모두 들어가는 경우 정규식
            var automaticNewsItemContentRegex = /새로운 공고가 등록되었습니다\.\s*공고제목\s*:\s*.+\s*모집기간\s*:\s*.+\s*상세url\s*:\s*.+/;
            var isAutomaticNewsItem = automaticNewsItemContentRegex.test(escapedHtmlTag);
            // "공고제목 :" 이후부터 "모집기간 :"전까지의 문자열을 추출하는 정규식
            var escapePrefixRegex = /공고제목 : (.*?)모집기간 :/;
            var escapedPrefix = ((ref1 = escapedHtmlTag.match(escapePrefixRegex)) === null || ref1 === void 0 ? void 0 : ref1[1]) || "";
            return {
                href: (0,util/* getWebviewHref */.ys)("/channel/".concat(newsItem === null || newsItem === void 0 ? void 0 : (ref2 = newsItem.channel) === null || ref2 === void 0 ? void 0 : ref2.url, "/").concat(newsItem === null || newsItem === void 0 ? void 0 : newsItem.id), isWebview),
                content: "[".concat(channelNameEllipsis, "] ").concat(isAutomaticNewsItem ? escapedPrefix : escapedHtmlTag),
                commentCount: (newsItem === null || newsItem === void 0 ? void 0 : newsItem.newsCommentCount) || 0
            };
        })) || [];
        return result;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tab-box",
                children: channelBestTabs.map(function(tab) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "tab",
                        "data-active": tab.active,
                        onClick: tab.onClick,
                        children: tab.label
                    }, tab.label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BestStoryList/* default */.Z, {
                data: dataSet,
                loading: loading
            })
        ]
    });
};
/* harmony default export */ var channelBestStory_ChannelBestPost = (ChannelBestPost);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChannelBestPost__StyledWrapper",
    componentId: "sc-57973cb8-0"
})(_templateObject1());

// EXTERNAL MODULE: ./src/generated/graphql.community.ts
var graphql_community = __webpack_require__(35888);
;// CONCATENATED MODULE: ./src/app.components/BestStory/BestStoryAll/hooks/usePostBestTabs.ts


var usePostBestTabs = function() {
    var ref = (0,react.useState)(graphql_community/* BestPostListType.RECENT */.vS.RECENT), currentTab = ref[0], setCurrentTab = ref[1];
    var PostBestTabs = (0,react.useMemo)(function() {
        return [
            {
                label: "실시간",
                active: currentTab === graphql_community/* BestPostListType.RECENT */.vS.RECENT,
                onClick: function() {
                    return setCurrentTab(graphql_community/* BestPostListType.RECENT */.vS.RECENT);
                }
            },
            {
                label: "주간",
                active: currentTab === graphql_community/* BestPostListType.LAST_WEEK */.vS.LAST_WEEK,
                onClick: function() {
                    return setCurrentTab(graphql_community/* BestPostListType.LAST_WEEK */.vS.LAST_WEEK);
                }
            },
            {
                label: "월간",
                active: currentTab === graphql_community/* BestPostListType.LAST_MONTH */.vS.LAST_MONTH,
                onClick: function() {
                    return setCurrentTab(graphql_community/* BestPostListType.LAST_MONTH */.vS.LAST_MONTH);
                }
            },
            {
                label: "댓글순",
                active: currentTab === graphql_community/* BestPostListType.REPLY_COUNT */.vS.REPLY_COUNT,
                onClick: function() {
                    return setCurrentTab(graphql_community/* BestPostListType.REPLY_COUNT */.vS.REPLY_COUNT);
                }
            },
            {
                label: "추천순",
                active: currentTab === graphql_community/* BestPostListType.VOTE_COUNT */.vS.VOTE_COUNT,
                onClick: function() {
                    return setCurrentTab(graphql_community/* BestPostListType.VOTE_COUNT */.vS.VOTE_COUNT);
                }
            }, 
        ];
    }, [
        currentTab
    ]);
    return {
        currentTab: currentTab,
        PostBestTabs: PostBestTabs
    };
};
/* harmony default export */ var hooks_usePostBestTabs = (usePostBestTabs);

;// CONCATENATED MODULE: ./src/app.components/BestStory/BestStoryAll/communityBestStory/CommunityBestPost.tsx

function CommunityBestPost_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px 20px 0px;\n  .tab-box {\n    display: flex;\n    gap: 16px;\n    .tab {\n      cursor: pointer;\n      border: none;\n      padding: 0px;\n      background: none;\n      font-size: 14px;\n      font-weight: 500;\n      color: #666;\n      &[data-active='true'] {\n        color: #01a0ff;\n        font-weight: bold;\n      }\n      :hover {\n        color: #01a0ff;\n      }\n    }\n  }\n"
    ]);
    CommunityBestPost_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CommunityBestPost = function() {
    var ref, ref1;
    var ref2 = hooks_usePostBestTabs(), currentTab = ref2.currentTab, PostBestTabs = ref2.PostBestTabs;
    var ref3 = (0,graphql_community/* useGqlBestPostListQuery */.J1)({
        variables: {
            input: {
                type: currentTab,
                pagination: {
                    page: 1,
                    pageSize: 10
                }
            }
        },
        context: {
            clientName: "community",
            headers: {
                "community-type": "community"
            }
        },
        fetchPolicy: "no-cache"
    }), data = ref3.data, loading = ref3.loading;
    var dataSet = (data === null || data === void 0 ? void 0 : (ref = data.bestPostList) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPosts) === null || ref1 === void 0 ? void 0 : ref1.map(function(post) {
        var ref;
        return {
            href: post.url || "",
            content: ((ref = post.title) === null || ref === void 0 ? void 0 : ref.replace(/<[^>]*>?/g, "")) || "",
            commentCount: post.commentCount
        };
    })) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommunityBestPost_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tab-box",
                children: PostBestTabs.map(function(tab) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "tab",
                        "data-active": tab.active,
                        onClick: tab.onClick,
                        children: tab.label
                    }, tab.label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BestStoryList/* default */.Z, {
                data: dataSet,
                loading: loading
            })
        ]
    });
};
/* harmony default export */ var communityBestStory_CommunityBestPost = (CommunityBestPost);
var CommunityBestPost_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CommunityBestPost__StyledWrapper",
    componentId: "sc-d693673-0"
})(CommunityBestPost_templateObject());

;// CONCATENATED MODULE: ./src/app.components/BestStory/BestStoryAll/hooks/useCurrentMenu.tsx


var useCurrentMenu = function() {
    var ref = (0,react.useState)(null), currentMenu = ref[0], setCurrentMenu = ref[1];
    var changeCurrentMenu = function(menu) {
        return setCurrentMenu(menu);
    };
    (0,react.useEffect)(function() {
        setCurrentMenu(Math.random() < 0.5 ? enums/* BestStoryType.CHANNEL */.k.CHANNEL : enums/* BestStoryType.COMMUNITY */.k.COMMUNITY);
    }, []);
    return {
        currentMenu: currentMenu,
        changeCurrentMenu: changeCurrentMenu
    };
};
/* harmony default export */ var hooks_useCurrentMenu = (useCurrentMenu);

;// CONCATENATED MODULE: ./src/app.components/BestStory/BestStoryAll/BestStoryAll.tsx

function BestStoryAll_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-top: 20px;\n  .menu-box {\n    display: flex;\n    border-bottom: 1px solid #e8e8e8;\n    .menu-title {\n      width: 100%;\n      height: 40px;\n      border: none;\n      background: none;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      &[data-active='true'] {\n        color: #01a0ff;\n        font-weight: bold;\n        border-bottom: 2px solid #01a0ff;\n      }\n      :hover {\n        color: #01a0ff;\n      }\n    }\n  }\n  .list-box {\n    height: 400px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    .expand-btn {\n      cursor: pointer;\n      font-size: 12px;\n      border: none;\n      background: none;\n      width: fit-content;\n      margin: 20px;\n      padding: 0px;\n      svg {\n        width: 10px;\n        height: 10px;\n        transform: translateY(0.5px);\n      }\n    }\n  }\n"
    ]);
    BestStoryAll_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var BestStoryAll = function() {
    var ref = (0,context/* useDomain */.ay)(), protocol = ref.protocol, xen = ref.xen;
    var ref1 = hooks_useCurrentMenu(), currentMenu = ref1.currentMenu, changeCurrentMenu = ref1.changeCurrentMenu;
    var expandLabel = (0,react.useMemo)(function() {
        if (currentMenu === enums/* BestStoryType.COMMUNITY */.k.COMMUNITY) return "커뮤니티 더보기";
        if (currentMenu === enums/* BestStoryType.CHANNEL */.k.CHANNEL) return "채널 더보기";
        return "더보기";
    }, [
        currentMenu
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BestStoryAll_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "menu-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "menu-title",
                        "data-active": currentMenu === enums/* BestStoryType.COMMUNITY */.k.COMMUNITY,
                        onClick: function() {
                            return changeCurrentMenu(enums/* BestStoryType.COMMUNITY */.k.COMMUNITY);
                        },
                        children: "커뮤니티"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "menu-title",
                        "data-active": currentMenu === enums/* BestStoryType.CHANNEL */.k.CHANNEL,
                        onClick: function() {
                            return changeCurrentMenu(enums/* BestStoryType.CHANNEL */.k.CHANNEL);
                        },
                        children: "채널"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "list-box",
                children: [
                    currentMenu === enums/* BestStoryType.COMMUNITY */.k.COMMUNITY && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(communityBestStory_CommunityBestPost, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "".concat(protocol, "://").concat(xen, "/best"),
                                className: "expand-btn",
                                children: [
                                    expandLabel,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowRight */.ol, {})
                                ]
                            })
                        ]
                    }),
                    currentMenu === enums/* BestStoryType.CHANNEL */.k.CHANNEL && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(channelBestStory_ChannelBestPost, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/channel",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "expand-btn",
                                    children: [
                                        expandLabel,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowRight */.ol, {})
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BestStoryAll_BestStoryAll = (BestStoryAll);
var BestStoryAll_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BestStoryAll__StyledWrapper",
    componentId: "sc-63e50bf-0"
})(BestStoryAll_templateObject());

;// CONCATENATED MODULE: ./src/app.components/BestStory/BestStoryAll/cbtBestStory/CbtBestPost.tsx

function CbtBestPost_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px 20px 0px;\n  .tab-box {\n    display: flex;\n    gap: 16px;\n    .tab {\n      cursor: pointer;\n      border: none;\n      padding: 0px;\n      background: none;\n      font-size: 14px;\n      font-weight: 500;\n      color: #666;\n      &[data-active='true'] {\n        color: #01a0ff;\n        font-weight: bold;\n      }\n      :hover {\n        color: #01a0ff;\n      }\n    }\n  }\n"
    ]);
    CbtBestPost_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CbtBestPost = function() {
    var ref, ref1;
    var ref2 = hooks_usePostBestTabs(), currentTab = ref2.currentTab, PostBestTabs = ref2.PostBestTabs;
    var ref3 = (0,graphql_community/* useGqlCbtBestPostListQuery */.NI)({
        variables: {
            input: {
                type: currentTab,
                pagination: {
                    page: 1,
                    pageSize: 10
                }
            }
        },
        context: {
            clientName: "community",
            headers: {
                "community-type": "cbt-community"
            }
        },
        fetchPolicy: "no-cache"
    }), data = ref3.data, loading = ref3.loading;
    var dataSet = (data === null || data === void 0 ? void 0 : (ref = data.bestPostList) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPosts) === null || ref1 === void 0 ? void 0 : ref1.map(function(post) {
        var ref;
        return {
            href: post.url || "",
            content: ((ref = post.title) === null || ref === void 0 ? void 0 : ref.replace(/<[^>]*>?/g, "")) || "",
            commentCount: post.commentCount
        };
    })) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CbtBestPost_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tab-box",
                children: PostBestTabs.map(function(tab) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "tab",
                        "data-active": tab.active,
                        onClick: tab.onClick,
                        children: tab.label
                    }, tab.label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BestStoryList/* default */.Z, {
                data: dataSet,
                loading: loading
            })
        ]
    });
};
/* harmony default export */ var cbtBestStory_CbtBestPost = (CbtBestPost);
var CbtBestPost_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CbtBestPost__StyledWrapper",
    componentId: "sc-dbe10777-0"
})(CbtBestPost_templateObject());

// EXTERNAL MODULE: ./src/app.components/BestStory/BestStoryHeader.tsx
var BestStoryHeader = __webpack_require__(77954);
;// CONCATENATED MODULE: ./src/app.components/BestStory/BestStory.tsx

function BestStory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    min-height: 411px;\n    background-color: ",
        ";\n    &[data-all='true'] {\n      min-height: 500px;\n    }\n    &[data-border='true'] {\n      border: 1px solid ",
        ";\n      ",
        "\n    }\n    &[data-radius='true'] {\n      border-radius: 5px;\n    }\n    &[data-small='true'] {\n      .tab-box {\n        display: flex;\n        justify-content: space-between;\n        gap: 0;\n      }\n    }\n  "
    ]);
    BestStory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BestStory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    BestStory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var BestStory = function(param) {
    var type = param.type, _isExpandBtn = param.isExpandBtn, isExpandBtn = _isExpandBtn === void 0 ? true : _isExpandBtn, _isBorder = param.isBorder, isBorder = _isBorder === void 0 ? true : _isBorder, _isRadius = param.isRadius, isRadius = _isRadius === void 0 ? false : _isRadius, _size = param.size, size = _size === void 0 ? "large" : _size, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BestStory_StyledWrapper, {
        className: className,
        "data-border": isBorder,
        "data-radius": isRadius,
        "data-small": size === "small",
        "data-all": type === enums/* BestStoryType.ALL */.k.ALL,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BestStoryHeader/* default */.Z, {
                type: type,
                isExpandBtn: isExpandBtn
            }),
            type === enums/* BestStoryType.COMMUNITY */.k.COMMUNITY && /*#__PURE__*/ (0,jsx_runtime.jsx)(communityBestStory_CommunityBestPost, {}),
            type === enums/* BestStoryType.CBT_COMMUNITY */.k.CBT_COMMUNITY && /*#__PURE__*/ (0,jsx_runtime.jsx)(cbtBestStory_CbtBestPost, {}),
            type === enums/* BestStoryType.ALL */.k.ALL && /*#__PURE__*/ (0,jsx_runtime.jsx)(BestStoryAll_BestStoryAll, {})
        ]
    });
};
/* harmony default export */ var BestStory_BestStory = (BestStory);
var BestStory_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BestStory__StyledWrapper",
    componentId: "sc-c03dd99d-0"
})(BestStory_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(BestStory_templateObject(), theme.background.bg_8, theme.line.line_3, theme.isMobile && "border: none;");
});

;// CONCATENATED MODULE: ./src/app.components/BestStory/index.ts

/* harmony default export */ var app_components_BestStory = (BestStory_BestStory);


/***/ }),

/***/ 35617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7029);

/* harmony default export */ __webpack_exports__["Z"] = (_Modal__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 57628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ BestStoryType; },
/* harmony export */   "r": function() { return /* binding */ ChannelUserType; }
/* harmony export */ });
var BestStoryType;
(function(BestStoryType) {
    BestStoryType["CHANNEL"] = "channel";
    BestStoryType["COMMUNITY"] = "community";
    BestStoryType["CBT_COMMUNITY"] = "cbtCommunity";
    BestStoryType["ALL"] = "all";
})(BestStoryType || (BestStoryType = {}));
var ChannelUserType;
(function(ChannelUserType) {
    ChannelUserType["NORMAL"] = "normal";
    ChannelUserType["CHANNEL"] = "channel";
    ChannelUserType["OWNER"] = "owner";
})(ChannelUserType || (ChannelUserType = {}));


/***/ }),

/***/ 20124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ chatMessage_MessageContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
;// CONCATENATED MODULE: ./src/app.feature/activityDetail/components/chatMessage/CbtExamMessage.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CbtExamMessage_embedData on EmbedData {\n    embedType\n    title\n    subtitle\n    content\n    url\n    urlText\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 225px;\n    border-radius: 8px;\n    background-color: #f3f4f8;\n    padding: 10px 12px;\n\n    &.sender {\n      background-color: #eaf8ff;\n    }\n\n    & > strong {\n      width: 100%;\n      height: 29px;\n      font-size: 13px;\n      font-weight: bold;\n      line-height: 19px;\n      letter-spacing: -0.56px;\n      text-align: left;\n      color: ",
        ";\n      border-bottom: 1px solid ",
        ";\n      display: block;\n      padding-bottom: 10px;\n      margin-bottom: 10px;\n    }\n\n    & > .embed-subtitle {\n      width: 100%;\n      min-height: 22px;\n      font-size: 15px;\n      font-weight: 500;\n      line-height: 22px;\n      color: ",
        ";\n      margin-bottom: 4px;\n    }\n\n    & > span {\n      width: 100%;\n      font-size: 15px;\n      font-weight: normal;\n      word-break: break-all;\n      color: ",
        ";\n      display: block;\n      margin-bottom: 15px;\n    }\n\n    & > a {\n      width: 100%;\n      height: 40px;\n      font-size: 13px;\n      font-weight: bold;\n      line-height: 40px;\n      text-align: center;\n      color: #ffffff;\n      border-radius: 8px;\n      background-color: ",
        ";\n      display: block;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




src_default()(_templateObject());
var CbtExamMessage = function(param) {
    var embedData = param.embedData, viewerIsSender = param.viewerIsSender;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        className: viewerIsSender ? "sender" : "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: embedData.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "embed-subtitle",
                children: [
                    "[",
                    embedData.subtitle,
                    "]"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: embedData.content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: embedData.url || "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: embedData.urlText
                })
            })
        ]
    });
};
/* harmony default export */ var chatMessage_CbtExamMessage = (CbtExamMessage);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CbtExamMessage__StyledWrapper",
    componentId: "sc-db299939-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), theme.color.text_1, theme.line.line_1, theme.color.text_1, theme.color.text_1, theme.color.primary_2);
});

// EXTERNAL MODULE: ./src/app.feature/activityDetail/hooks/useShowComponentByAppVersion.ts
var useShowComponentByAppVersion = __webpack_require__(98284);
// EXTERNAL MODULE: ./src/constants/verifyAppVersion/verifyAppVersionList.ts
var verifyAppVersionList = __webpack_require__(58432);
;// CONCATENATED MODULE: ./src/app.feature/activityDetail/components/chatMessage/TeamRecruitMessage.tsx

function TeamRecruitMessage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment TeamRecruitMessage_embedData on EmbedData {\n    embedType\n    title\n    subtitle\n    content\n    url\n    urlText\n  }\n"
    ]);
    TeamRecruitMessage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TeamRecruitMessage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 225px;\n    border-radius: 8px;\n    background-color: #f3f4f8;\n    padding: 10px 12px;\n\n    &.sender {\n      background-color: #eaf8ff;\n    }\n\n    .team-recruit-embed-header {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      padding-bottom: 8px;\n      border-bottom: 1px solid ",
        ";\n\n      > strong {\n        font-size: 13px;\n        line-height: 19px;\n        letter-spacing: -0.52px;\n        color: ",
        ";\n        display: block;\n      }\n\n      > .team-recruit-region-tag {\n        display: inline-flex;\n        align-items: center;\n        height: 24px;\n        background-color: ",
        ";\n        border-radius: 5px;\n        padding: 4px 7px;\n        font-size: ",
        ";\n        font-weight: bold;\n        color: ",
        ";\n        letter-spacing: -0.48px;\n      }\n    }\n\n    & > span {\n      width: 100%;\n      font-size: 15px;\n      font-weight: normal;\n      word-break: break-all;\n      color: ",
        ";\n      display: block;\n      margin: 7px 0 12px;\n    }\n\n    & > .app-update-message {\n      margin: 0;\n      font-size: 14px;\n    }\n\n    & > a {\n      width: 100%;\n      height: 32px;\n      font-size: 12px;\n      font-weight: bold;\n      line-height: 32px;\n      text-align: center;\n      color: #ffffff;\n      border-radius: 8px;\n      background-color: ",
        ";\n      display: block;\n    }\n  "
    ]);
    TeamRecruitMessage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TeamRecruitMessage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    TeamRecruitMessage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






src_default()(TeamRecruitMessage_templateObject());
var TeamRecruitMessage = function(param) {
    var embedData = param.embedData, viewerIsSender = param.viewerIsSender;
    var isTeamRecruitVisibleVersion = (0,useShowComponentByAppVersion/* default */.Z)(verifyAppVersionList/* VERIFIED_APP_VERSIONS.TEAM_RECRUIT */.sJ.TEAM_RECRUIT);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamRecruitMessage_StyledWrapper, {
        className: viewerIsSender ? "sender" : "",
        children: isTeamRecruitVisibleVersion ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "team-recruit-embed-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "team-recruit-region-tag",
                            children: embedData.subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: embedData.title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: embedData.content
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: embedData.url || "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: embedData.urlText
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "app-update-message",
            children: "앱 업데이트 후 채팅을 확인해보세요"
        })
    });
};
/* harmony default export */ var chatMessage_TeamRecruitMessage = (TeamRecruitMessage);
var TeamRecruitMessage_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TeamRecruitMessage__StyledWrapper",
    componentId: "sc-b53c329d-0"
})(TeamRecruitMessage_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(TeamRecruitMessage_templateObject1(), theme.line.line_2, theme.color.text_1, theme.background.bg_8, theme.isMobile ? "11px" : "12px", theme.color.primary_2, theme.color.text_1, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/activityDetail/components/chatMessage/MessageContent.tsx




var MessageContent = function(param) {
    var embedData = param.embedData, content = param.content, viewerIsSender = param.viewerIsSender;
    switch(embedData === null || embedData === void 0 ? void 0 : embedData.embedType){
        case graphql/* EmbedType.CBT_EXAM */.b_7.CBT_EXAM:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(chatMessage_CbtExamMessage, {
                embedData: embedData,
                viewerIsSender: viewerIsSender
            });
        case graphql/* EmbedType.TEAM_RECRUIT */.b_7.TEAM_RECRUIT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(chatMessage_TeamRecruitMessage, {
                embedData: embedData,
                viewerIsSender: viewerIsSender
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "message-content",
                children: content
            });
    }
};
/* harmony default export */ var chatMessage_MessageContent = (MessageContent);


/***/ }),

/***/ 98284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10253);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12102);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52737);
/* harmony import */ var _app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67235);
/* harmony import */ var constants_verifyAppVersion_verifyAppVersionList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58432);





/**
 * 앱 버전에 따라 특정 기능의 노출 여부를 판단하는 범용 훅입니다.
 *
 * 특정 버전 이상일 경우에만 관련 영역이 노출될 수 있도록 Boolean값을 반환하며,
 * 웹뷰가 아닐 경우 무조건 true를 반환합니다.
 *
 * @param versionKey - 확인할 버전 키
 * - 'CAREER_NAVER_LICENSE': 네이버 자격증 연동
 * - 'COVER_LETTER_AD_EDUCATION': 자만검 배너 및 공고 상세 추천 교육
 * - 'SCRAP_USER_STATISTICS': 공고 상세 관심 유저 통계
 * - 'TEAM_RECRUIT': 팀원 모집
 * - 'COMPANY_INFO': 기업정보 더보기
 * @returns {boolean} 기능 노출 여부
 */ var useShowComponentByAppVersion = function(versionKey) {
    var isWebview = (0,_app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,react_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), 1), cookies = ref[0];
    var verifyAppVersionRequirement = (0,context__WEBPACK_IMPORTED_MODULE_0__/* .useWebview */ .sW)({
        appVersion: cookies === null || cookies === void 0 ? void 0 : cookies.appVersion
    }).verifyAppVersionRequirement;
    var isComponentVisible = isWebview ? verifyAppVersionRequirement({
        ios: constants_verifyAppVersion_verifyAppVersionList__WEBPACK_IMPORTED_MODULE_2__/* .IOS_APP_VERSIONS */ .ZQ[versionKey],
        aos: constants_verifyAppVersion_verifyAppVersionList__WEBPACK_IMPORTED_MODULE_2__/* .AOS_APP_VERSIONS */ .hk[versionKey]
    }) : true;
    return isComponentVisible;
};
/* harmony default export */ __webpack_exports__["Z"] = (useShowComponentByAppVersion);


/***/ }),

/***/ 20720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qu": function() { return /* binding */ convertToHexCodeColor; },
/* harmony export */   "bH": function() { return /* binding */ convertActivityName; },
/* harmony export */   "wl": function() { return /* binding */ checkMessageSenderInfo; }
/* harmony export */ });
/* harmony import */ var date_fns_getHours__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85817);
/* harmony import */ var date_fns_getMinutes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39159);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35460);




/**
 * @desc api 에서 받아온 색상 코드를 css에서 사용할 수 있는 rgba() 형태로 변환합니다.
 * @param color 0xAARRGGBB (알파값이 앞에 있는 형태)
 * @returns rgba()
 */ var convertToHexCodeColor = function(color) {
    if (!color) return "";
    var alpha = color.slice(2, 4);
    var red = color.slice(4, 6);
    var green = color.slice(6, 8);
    var blue = color.slice(8, 10);
    return "#".concat(red).concat(green).concat(blue).concat(alpha);
};
/**
 * @desc activityTypeId 따라 '인사담당자' 또는 '담당자' 텍스트를 추가합니다
 * @param activityTypeId 채팅방 타입
 * @returns
 */ var convertActivityName = function(activityTypeId) {
    if (activityTypeId === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN || activityTypeId === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT) {
        return "인사담당자";
    } else if (activityTypeId === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY || activityTypeId === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST) {
        return "담당자";
    } else {
        return "";
    }
};
/**
 * @description 채팅방의 sender 정보를 받아 멘토인지 확인합니다.
 * @param sender
 * @returns
 */ var checkMessageSenderInfo = function(message) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    // 기업 담당자 정보
    var isUnverifiedManager = ((ref = message.sender) === null || ref === void 0 ? void 0 : ref.chatUserType) === generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserType.MANAGER_UNVERIFIED */ .FWD.MANAGER_UNVERIFIED;
    var organizationManager = isUnverifiedManager ? "".concat((ref1 = message.sender) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatOrganization) === null || ref2 === void 0 ? void 0 : ref2.name) : undefined;
    // 멘토 담당자 정보
    var isApprovedMentor = ((ref3 = message.sender) === null || ref3 === void 0 ? void 0 : ref3.chatMentorAuthenticationStatus) === "APPROVED";
    var mentorDutyInfo = ((ref4 = message.sender) === null || ref4 === void 0 ? void 0 : ref4.chatMentorDutyName) ? "\xb7 ".concat(message.sender.chatMentorDutyName) : "";
    var mentorUser = isApprovedMentor ? "".concat((ref5 = message.sender) === null || ref5 === void 0 ? void 0 : ref5.chatMentorOrganizationName, " ").concat(mentorDutyInfo) : undefined;
    // 메세지 작성 시간
    var messageCreatedAt = "".concat((0,date_fns_getHours__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(message.createdAt), " : ").concat((0,date_fns_getMinutes__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(message.createdAt).toString().padStart(2, "0"));
    return {
        organizationManager: organizationManager,
        mentorUser: mentorUser,
        messageCreatedAt: messageCreatedAt
    };
};


/***/ }),

/***/ 22701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NU": function() { return /* binding */ PC_AD_CODE; },
/* harmony export */   "Q7": function() { return /* binding */ AD_CODE_ID; },
/* harmony export */   "s6": function() { return /* binding */ ACTIVITY_NOTICE_AD_CODE_ID; },
/* harmony export */   "xB": function() { return /* binding */ EDUCATION_RECOMMENDATION_AD_CODE_ID; }
/* harmony export */ });
/* unused harmony exports MOBILE_AD_CODE, ACTIVITY_NOTICE_AD_CODE */
var PC_AD_CODE;
(function(PC_AD_CODE) {
    PC_AD_CODE["MAIN"] = "pc-main-list-banner";
    PC_AD_CODE["HOTLINE"] = "pc-hotline-banner";
    PC_AD_CODE["RECOMMEND_ACTIVITY_S"] = "pc-recommend-activity-s-banner";
    PC_AD_CODE["RECOMMEND_ACTIVITY_A"] = "pc-recommend-activity-a-banner";
    PC_AD_CODE["WEEKLY_POPULAR"] = "pc-weekly-popular-activity";
    PC_AD_CODE["RECRUIT"] = "pc-recruit-banner";
    PC_AD_CODE["RIGHT_SIDEBAR"] = "pc-right-sidebar-all-of-page";
    PC_AD_CODE["HORIZONTAL"] = "web-activity-horizontal-ad";
    PC_AD_CODE["RECRUIT_QNA_BOTTOM"] = "pc-recruit-qna-bottom";
    PC_AD_CODE["COVER_LETTER_SEARCH"] = "pc-coverletter-search-banner";
    PC_AD_CODE["LIVE_ACTIVITY"] = "live-activity";
    PC_AD_CODE["FULLSCREEN_POPUP"] = "pc-full-popup";
    PC_AD_CODE["EDUCATION_TOP_PINNED_BANNER"] = "pc-education-top-pinned-banner";
})(PC_AD_CODE || (PC_AD_CODE = {}));
var MOBILE_AD_CODE;
(function(MOBILE_AD_CODE) {
    MOBILE_AD_CODE["MAIN"] = "mobile-main-list-banner";
    MOBILE_AD_CODE["HOTLINE"] = "mobile-hotline-banner";
    MOBILE_AD_CODE["RECOMMEND_ACTIVITY_S"] = "mobile-recommend-activity-s-banner";
    MOBILE_AD_CODE["RECOMMEND_ACTIVITY_A"] = "mobile-recommend-activity-a-banner";
    MOBILE_AD_CODE["WEEKLY_POPULAR"] = "mobile-weekly-popular-activity";
    MOBILE_AD_CODE["RECRUIT"] = "mobile-recruit-banner";
    MOBILE_AD_CODE["RECRUIT_QNA_BOTTOM"] = "mobile-recruit-qna-bottom";
    MOBILE_AD_CODE["COVER_LETTER_SEARCH"] = "mobile-coverletter-search-banner";
    MOBILE_AD_CODE["LIVE_ACTIVITY"] = "live-activity";
    MOBILE_AD_CODE["FULLSCREEN_POPUP"] = "mobile-full-popup";
    MOBILE_AD_CODE["EDUCATION_TOP_PINNED_BANNER"] = "mobile-education-top-pinned-banner";
})(MOBILE_AD_CODE || (MOBILE_AD_CODE = {}));
var AD_CODE_ID = {
    MAIN: {
        PC: PC_AD_CODE.MAIN,
        MOBILE: MOBILE_AD_CODE.MAIN
    },
    HOTLINE: {
        PC: PC_AD_CODE.HOTLINE,
        MOBILE: MOBILE_AD_CODE.HOTLINE
    },
    RECOMMEND_ACTIVITY_S: {
        PC: PC_AD_CODE.RECOMMEND_ACTIVITY_S,
        MOBILE: MOBILE_AD_CODE.RECOMMEND_ACTIVITY_S
    },
    RECOMMEND_ACTIVITY_A: {
        PC: PC_AD_CODE.RECOMMEND_ACTIVITY_A,
        MOBILE: MOBILE_AD_CODE.RECOMMEND_ACTIVITY_A
    },
    LIVE_ACTIVITY: {
        PC: PC_AD_CODE.LIVE_ACTIVITY,
        MOBILE: MOBILE_AD_CODE.LIVE_ACTIVITY
    },
    WEEKLY_POPULAR: {
        PC: PC_AD_CODE.WEEKLY_POPULAR,
        MOBILE: MOBILE_AD_CODE.WEEKLY_POPULAR
    },
    RECRUIT: {
        PC: PC_AD_CODE.RECRUIT,
        MOBILE: MOBILE_AD_CODE.RECRUIT
    },
    RIGHT_SIDEBAR: {
        PC: PC_AD_CODE.RIGHT_SIDEBAR
    },
    HORIZONTAL: {
        PC: PC_AD_CODE.HORIZONTAL
    },
    RECRUIT_QNA_BOTTOM: {
        PC: PC_AD_CODE.RECRUIT_QNA_BOTTOM,
        MOBILE: MOBILE_AD_CODE.RECRUIT_QNA_BOTTOM
    },
    COVER_LETTER_SEARCH: {
        PC: PC_AD_CODE.COVER_LETTER_SEARCH,
        MOBILE: MOBILE_AD_CODE.COVER_LETTER_SEARCH
    },
    FULLSCREEN_POPUP: {
        PC: PC_AD_CODE.FULLSCREEN_POPUP,
        MOBILE: MOBILE_AD_CODE.FULLSCREEN_POPUP
    },
    EDUCATION_TOP_PINNED_BANNER: {
        PC: PC_AD_CODE.EDUCATION_TOP_PINNED_BANNER,
        MOBILE: MOBILE_AD_CODE.EDUCATION_TOP_PINNED_BANNER
    }
};
var ACTIVITY_NOTICE_AD_CODE;
(function(ACTIVITY_NOTICE_AD_CODE) {
    ACTIVITY_NOTICE_AD_CODE["INTERN_NOTICE"] = "activity-intern-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["RECRUIT_NOTICE"] = "activity-recruit-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["ACTIVITY_NOTICE"] = "activity-activity-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["CONTEST_NOTICE"] = "activity-contest-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["EDUCATION_NOTICE"] = "activity-education-notice-banner";
})(ACTIVITY_NOTICE_AD_CODE || (ACTIVITY_NOTICE_AD_CODE = {}));
var ACTIVITY_NOTICE_AD_CODE_ID = {
    INTERN_NOTICE: ACTIVITY_NOTICE_AD_CODE.INTERN_NOTICE,
    RECRUIT_NOTICE: ACTIVITY_NOTICE_AD_CODE.RECRUIT_NOTICE,
    ACTIVITY_NOTICE: ACTIVITY_NOTICE_AD_CODE.ACTIVITY_NOTICE,
    CONTEST_NOTICE: ACTIVITY_NOTICE_AD_CODE.CONTEST_NOTICE,
    EDUCATION_NOTICE: ACTIVITY_NOTICE_AD_CODE.EDUCATION_NOTICE
};
var EDUCATION_RECOMMENDATION_AD_CODE_ID = {
    PC: "pc-education-random-banner",
    MOBILE: "mobile-education-random-banner"
};


/***/ }),

/***/ 98693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ AD_IMPRESSION_THRESHOLD; },
/* harmony export */   "a0": function() { return /* binding */ TOTAL_AD_SLOTS; },
/* harmony export */   "qe": function() { return /* binding */ TOTAL_ACTIVITY_AD_SLOTS; }
/* harmony export */ });
var AD_IMPRESSION_THRESHOLD = 0.9;
var TOTAL_AD_SLOTS = 4;
var TOTAL_ACTIVITY_AD_SLOTS = 12;


/***/ }),

/***/ 80979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ACTIVITY_GTM_EVENT; },
/* harmony export */   "c": function() { return /* binding */ GTM_EVENT; }
/* harmony export */ });
/**
 * 광고 영역별 GTM 이벤트 정의
 */ var GTM_EVENT = {
    MAIN: {
        PC: {
            CLICK_EVENT: "pc_main_list_bnr_clk",
            IMPRESSION_EVENT: "pc_main_list_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_main_list_bnr_clk",
            IMPRESSION_EVENT: "mo_main_list_bnr_imp"
        }
    },
    HOTLINE: {
        PC: {
            CLICK_EVENT: "pc_hotline_bnr_clk",
            IMPRESSION_EVENT: "pc_hotline_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_hotline_bnr_clk",
            IMPRESSION_EVENT: "mo_hotline_bnr_imp"
        }
    },
    RECOMMEND_ACTIVITY_S: {
        PC: {
            CLICK_EVENT: "pc_rec_act_s_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_act_s_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_act_s_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_act_s_bnr_imp"
        }
    },
    RECOMMEND_ACTIVITY_A: {
        PC: {
            CLICK_EVENT: "pc_rec_act_a_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_act_a_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_act_a_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_act_a_bnr_imp"
        }
    },
    WEEKLY_POPULAR: {
        PC: {
            CLICK_EVENT: "pc_wkly_pop_act_clk",
            IMPRESSION_EVENT: "pc_wkly_pop_act_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_wkly_pop_act_clk",
            IMPRESSION_EVENT: "mo_wkly_pop_act_imp"
        }
    },
    RECRUIT: {
        PC: {
            CLICK_EVENT: "pc_rec_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_bnr_imp"
        }
    },
    RIGHT_SIDEBAR: {
        PC: {
            CLICK_EVENT: "pc_rgt_side_all_pg_clk",
            IMPRESSION_EVENT: "pc_rgt_side_all_pg_imp"
        }
    },
    HORIZONTAL: {
        PC: {
            CLICK_EVENT: "pc_horz_ad_clk",
            IMPRESSION_EVENT: "pc_horz_ad_imp"
        }
    },
    RECRUIT_QNA_BOTTOM: {
        PC: {
            CLICK_EVENT: "pc_rec_qna_btm_clk",
            IMPRESSION_EVENT: "pc_rec_qna_btm_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_qna_btm_clk",
            IMPRESSION_EVENT: "mo_rec_qna_btm_imp"
        },
        APP: {
            CLICK_EVENT: "app_rec_qna_btm_clk",
            IMPRESSION_EVENT: "app_rec_qna_btm_imp"
        }
    },
    COVER_LETTER_SEARCH: {
        PC: {
            CLICK_EVENT: "pc_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "pc_cvlt_srch_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "mo_cvlt_srch_bnr_imp"
        },
        APP: {
            CLICK_EVENT: "app_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "app_cvlt_srch_bnr_imp"
        }
    },
    LIVE_ACTIVITY: {
        PC: {
            CLICK_EVENT: "pc_live_act_clk",
            IMPRESSION_EVENT: "pc_live_act_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_live_act_clk",
            IMPRESSION_EVENT: "mo_live_act_imp"
        }
    },
    FULLSCREEN_POPUP: {
        PC: {
            CLICK_EVENT: "pc_full_pop_clk",
            IMPRESSION_EVENT: "pc_full_pop_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_full_pop_clk",
            IMPRESSION_EVENT: "mo_full_pop_imp"
        }
    },
    EDUCATION_TOP_PINNED_BANNER: {
        PC: {
            CLICK_EVENT: "pc_edu_top_pinned_bnr_clk",
            IMPRESSION_EVENT: "pc_edu_top_pinned_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_edu_top_pinned_bnr_clk",
            IMPRESSION_EVENT: "mo_edu_top_pinned_bnr_imp"
        },
        APP: {
            IMPRESSION_EVENT: "app_edu_top_pinned_bnr_imp",
            CLICK_EVENT: "app_edu_top_pinned_bnr_clk"
        }
    }
};
var ACTIVITY_GTM_EVENT = {
    INTERN_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_int_ntc_bnr_imp",
            CLICK_EVENT: "pc_int_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_int_ntc_bnr_imp",
            CLICK_EVENT: "mo_int_ntc_bnr_clk"
        }
    },
    RECRUIT_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_rec_ntc_bnr_imp",
            CLICK_EVENT: "pc_rec_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_rec_ntc_bnr_imp",
            CLICK_EVENT: "mo_rec_ntc_bnr_clk"
        }
    },
    ACTIVITY_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_act_ntc_bnr_imp",
            CLICK_EVENT: "pc_act_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_act_ntc_bnr_imp",
            CLICK_EVENT: "mo_act_ntc_bnr_clk"
        }
    },
    CONTEST_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_ctst_ntc_bnr_imp",
            CLICK_EVENT: "pc_ctst_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_ctst_ntc_bnr_imp",
            CLICK_EVENT: "mo_ctst_ntc_bnr_clk"
        }
    },
    EDUCATION_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_edu_ntc_bnr_imp",
            CLICK_EVENT: "pc_edu_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_edu_ntc_bnr_imp",
            CLICK_EVENT: "mo_edu_ntc_bnr_clk"
        },
        APP: {
            IMPRESSION_EVENT: "app_edu_ntc_bnr_imp",
            CLICK_EVENT: "app_edu_ntc_bnr_clk"
        }
    }
};


/***/ }),

/***/ 28737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98693);



/**
 * 단일 광고 요소가 90% 이상 viewport에 노출되었을 때 impression을 추적하는 커스텀 훅
 *
 * @description
 * 광고 영역이 90% 이상 노출될 때마다 onVisible 콜백 함수를 호출합니다.
 *
 * @param {Object} params - 훅 파라미터
 * @param {Function} params.onVisible - 광고가 viewport에 노출되었을 때 호출되는 콜백 함수
 * @param {Array} [params.dependencies] - useEffect의 의존성 배열. 이 값들이 변경될 때마다 impression을 다시 추적합니다.
 * @param {boolean} params.isOnlyFirst - true일 경우, 최초 노출 시에만 onVisible을 호출합니다. 기본값은 false입니다.
 *
 * @returns {Object} 훅 반환값
 * @returns {MutableRefObject<HTMLDivElement | null>} containerRef - 광고 컨테이너 요소를 참조하는 ref 객체
 */ var useAdImpressionTracking = function(param) {
    var onVisible = param.onVisible, _dependencies = param.dependencies, dependencies = _dependencies === void 0 ? [] : _dependencies, _isOnlyFirst = param.isOnlyFirst, isOnlyFirst = _isOnlyFirst === void 0 ? false : _isOnlyFirst;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!containerRef.current) return;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var isInViewport = entry.isIntersecting && entry.intersectionRatio >= _constants_constants__WEBPACK_IMPORTED_MODULE_1__/* .AD_IMPRESSION_THRESHOLD */ .BJ;
                if (isInViewport) {
                    onVisible();
                    if (isOnlyFirst) {
                        observer.disconnect();
                    }
                }
            });
        }, {
            threshold: [
                0.9
            ],
            root: null,
            rootMargin: "0px"
        });
        observer.observe(containerRef.current);
        return function() {
            return observer.disconnect();
        };
    }, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dependencies)) // 외부에서 전달받은 의존성 배열 사용
    ;
    return {
        containerRef: containerRef
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAdImpressionTracking);


/***/ }),

/***/ 82138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35460);



var useGetActivityListFromAdsByPlacementCode = function(param) {
    var adPlacementCode = param.adPlacementCode, restVariables = param.restVariables, activityTypeID = param.activityTypeID;
    var noticeBannerQueryVariables = {
        isEducation: activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION,
        isRecruit: activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT || activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN,
        isActivity: activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY || activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST
    };
    var ref = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlActivityListFromAdsByPlacementCodeQuery */ .PTF)({
        variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            adPlacementCode: adPlacementCode
        }, restVariables && restVariables, noticeBannerQueryVariables)
    }), data = ref.data, loading = ref.loading, error = ref.error;
    return {
        ads: data === null || data === void 0 ? void 0 : data.activityListFromAdsByPlacementCode,
        loading: loading,
        error: error
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetActivityListFromAdsByPlacementCode);


/***/ }),

/***/ 68545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32912);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47079);




/**
 * 단일한 랜덤의 광고 지면을 응답받아야 하는 경우 사용합니다.
 * @param  TUseGetAdByPlacementCodeAndCurrentTimeParams
 * @returns
 */ var useGetAdByPlacementCodeAndCurrentTime = function(param) {
    var code = param.code;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var page = router.query.page;
    var currentTime = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var currentDate = new Date();
        return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(currentDate, "HH:mm:ss");
    }, [
        page
    ]);
    var ref = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useGqlCurrentAdByPlacementCodeAndCurrentTimeQuery */ .hf9)({
        variables: {
            code: code,
            currentTime: currentTime
        }
    }), data = ref.data, loading = ref.loading, error = ref.error;
    return {
        ad: data === null || data === void 0 ? void 0 : data.currentAdByPlacementCodeAndCurrentTime,
        loading: loading,
        error: error
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetAdByPlacementCodeAndCurrentTime);


/***/ }),

/***/ 24033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ pushGTMCampaignId; }
/* harmony export */ });
/**
 * Campaign ID를 포함한 GTM 이벤트를 발생시키는 함수
 * window.dataLayer가 존재할 경우 이벤트를 push합니다.
 *
 * @param eventName - GTM에서 트리거로 사용될 이벤트 이름
 * @param campaignId - 캠페인 ID
 * @example
 * pushGTMCampaignId({
 *   eventName: 'view_campaign',
 *   campaign_id: '12345'
 * })
 */ var pushGTMCampaignId = function(param) {
    var eventName = param.eventName, campaignId = param.campaignId;
    if (!(window === null || window === void 0 ? void 0 : window.dataLayer) || !campaignId || !eventName) {
        return;
    }
    window.dataLayer.push({
        event: eventName,
        campaign_id: campaignId
    });
};


/***/ }),

/***/ 49045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ replaceStrToDots; }
/* harmony export */ });
var replaceStrToDots = function(str, limit) {
    if (str.length > limit) {
        str = str.slice(0, limit) + "...";
    }
    return str;
};


/***/ }),

/***/ 4970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ SIGNUP_MODAL_COOKIE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12102);
/* harmony import */ var date_fns_addDays__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77349);
/* harmony import */ var date_fns_startOfDay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69119);
/* harmony import */ var date_fns_tz__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43986);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15125);






var SIGNUP_MODAL_COOKIE = "signup-modal";
var useSignupCookies = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,react_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), 2), _ = ref[0], setCookies = ref[1];
    var getCookieDomain = function() {
        var url = window.location.href;
        if (url.includes("linkareer")) return ".linkareer.com";
        if (url.includes("lnkr")) return ".lnkr.cc";
        return "localhost";
    };
    var setSignupCookie = function(cookie, expires) {
        setCookies(cookie, Date.now(), {
            expires: expires,
            domain: getCookieDomain(),
            path: "/"
        });
    };
    var addSignupModalCookie = function() {
        var oneDay = (0,date_fns_tz__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,date_fns_startOfDay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,date_fns_addDays__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Date(), 1)), utils_config__WEBPACK_IMPORTED_MODULE_0__/* .TIMEZONE */ .aB) // 다음 날 자정 만료
        ;
        setSignupCookie(SIGNUP_MODAL_COOKIE, oneDay);
    };
    var removeSignupModalCookie = function() {
        setCookies(SIGNUP_MODAL_COOKIE, "", {
            expires: new Date(0),
            domain: getCookieDomain(),
            path: "/"
        });
    };
    return {
        addSignupModalCookie: addSignupModalCookie,
        removeSignupModalCookie: removeSignupModalCookie
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSignupCookies);


/***/ }),

/***/ 57967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_signup_signup_components_signupInfo_FieldBirthday__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34754);
/* harmony import */ var _app_feature_signup_signup_components_signupInfo_FieldSchool__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33400);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: grid;\n    margin-top: ",
        ";\n    gap: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var UserInfoModalInfo = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_signup_signup_components_signupInfo_FieldSchool__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_signup_signup_components_signupInfo_FieldBirthday__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UserInfoModalInfo);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "UserInfoModalInfo__StyledWrapper",
    componentId: "sc-3bb5a7e9-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), theme.isMobile ? "28px" : "32px", theme.isMobile ? "28px" : "31px");
});


/***/ }),

/***/ 55463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UserInfoModal_desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 5 modules
var parse = __webpack_require__(83366);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.components/Modal/index.tsx
var Modal = __webpack_require__(35617);
// EXTERNAL MODULE: ./src/app.feature/chatting/chattingContext/module/ChattingContext.tsx + 6 modules
var ChattingContext = __webpack_require__(18944);
// EXTERNAL MODULE: ./src/app.feature/signup/signup/components/SignupSubmitButton.tsx
var SignupSubmitButton = __webpack_require__(39766);
// EXTERNAL MODULE: ./src/app.feature/signup/signup/components/signupInterest/SignupInterest.tsx + 5 modules
var SignupInterest = __webpack_require__(53043);
// EXTERNAL MODULE: ./src/app.feature/signup/signup/components/signupInfo/FieldPhone.tsx + 4 modules
var FieldPhone = __webpack_require__(11706);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/MarkdownViewer.tsx
var MarkdownViewer = __webpack_require__(17999);
// EXTERNAL MODULE: ./src/constants/marketing/sms.ts
var sms = __webpack_require__(47742);
// EXTERNAL MODULE: ./src/svgIcons/ExpandMore.tsx
var ExpandMore = __webpack_require__(40934);
;// CONCATENATED MODULE: ./src/app.feature/userInfoModal/desktop/components/SubscribeSMS.desktop.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .checkbox-container {\n      font-size: 14px;\n      font-weight: 500;\n      font-stretch: normal;\n      font-style: normal;\n      line-height: 1.86;\n      letter-spacing: -0.56px;\n      > input[type='checkbox'] {\n        display: none;\n        &:checked + label {\n          background-color: ",
        ";\n          border: 0;\n          > .check-svg {\n            display: flex;\n            border-radius: 8px;\n          }\n        }\n      }\n      > label {\n        width: 22px;\n        height: 22px;\n        border-radius: 5px;\n        background: white;\n        border: 1px solid ",
        ";\n        .check-svg {\n          width: 22px;\n          height: 22px;\n          display: none;\n          align-items: center;\n          justify-content: center;\n        }\n      }\n      display: flex;\n      align-items: center;\n      gap: 9px;\n      .text-body {\n        flex: 1;\n        > .optional-sms {\n          color: ",
        ";\n        }\n      }\n    }\n    > .receive-message {\n      font-size: 12px;\n      letter-spacing: -0.48px;\n      color: ",
        ";\n    }\n    .policy-arrow-container {\n      display: flex;\n      gap: 3px;\n      cursor: pointer;\n      .arrow-wrapper {\n        display: flex;\n        align-items: center;\n      }\n      .opened {\n        rotate: 180deg;\n\n        transition-duration: 500ms;\n        transition-property: rotate;\n      }\n    }\n    .policy-scroll-container {\n      height: 137px;\n      overflow-y: scroll;\n      border: 1px solid #e3e3e3;\n      padding: 0 15px;\n      margin-top: 10px;\n    }\n    .hidden {\n      display: none;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var SubscribeSMSDesktop = function() {
    var register = (0,index_esm/* useFormContext */.Gc)().register;
    var ref = (0,react.useState)(false), isPolicyOpen = ref[0], setIsPolicyOpen = ref[1];
    var handleDetailClick = function() {
        setIsPolicyOpen(!isPolicyOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "checkbox-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        type: "checkbox",
                        id: "receive-sms"
                    }, register("subscribeSMS"))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "receive-sms",
                        className: "pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "check-svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/static/images/signup/ic-check-white.svg",
                                width: 13,
                                height: 10,
                                alt: "checked"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-body",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "optional-sms",
                                children: "(선택) "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text",
                                children: "마케팅 정보 수신 동의(SMS/MMS)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "policy-arrow-container",
                        onClick: handleDetailClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: isPolicyOpen ? "내용닫기" : "내용보기"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "arrow-wrapper ".concat(isPolicyOpen && "opened"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "receive-message",
                children: "*수신 동의해야 관심사에 대한 정보를 문자로 바로 받을 수 있어요"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "policy-scroll-container ".concat(!isPolicyOpen && "hidden"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownViewer/* MarkdownViewer */.a, {
                    content: sms/* MARKETING_SMS.slice */.h.slice(34)
                })
            })
        ]
    });
};
/* harmony default export */ var SubscribeSMS_desktop = (SubscribeSMSDesktop);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SubscribeSMS.desktop__StyledWrapper",
    componentId: "sc-5ebfacd3-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.color.primary_2, theme.line.line_2, theme.color.text_3, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/userInfoModal/desktop/components/ReceiveGuide.desktop.tsx

function ReceiveGuide_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    ReceiveGuide_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ReceiveGuideDesktop = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiveGuide_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldPhone/* default */.Z, {
                subTitle: "아이디 및 비밀번호를 찾거나 변경할 때 필요합니다"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeSMS_desktop, {})
        ]
    });
};
/* harmony default export */ var ReceiveGuide_desktop = (ReceiveGuideDesktop);
var ReceiveGuide_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReceiveGuide.desktop__StyledWrapper",
    componentId: "sc-3b72bcde-0"
})(ReceiveGuide_desktop_templateObject());

// EXTERNAL MODULE: ./src/app.feature/userInfoModal/hooks/useGetPreviousUserInfo.ts
var useGetPreviousUserInfo = __webpack_require__(77278);
// EXTERNAL MODULE: ./src/hooks/useCurrentUser.ts
var useCurrentUser = __webpack_require__(38405);
// EXTERNAL MODULE: ./src/svgIcons/Close.tsx
var Close = __webpack_require__(43785);
// EXTERNAL MODULE: ./src/app.feature/userInfoModal/components/UserInfoModalInfo.tsx
var UserInfoModalInfo = __webpack_require__(57967);
// EXTERNAL MODULE: ./src/app.feature/userInfoModal/schema/userInfoModalSchema.ts
var userInfoModalSchema = __webpack_require__(82033);
// EXTERNAL MODULE: ./src/app.feature/home/hook/useSignupCookies.ts
var useSignupCookies = __webpack_require__(4970);
;// CONCATENATED MODULE: ./src/app.feature/userInfoModal/desktop/components/UserInfoExitModal.desktop.tsx

function UserInfoExitModal_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 360px;\n    height: 227px;\n    padding: 50px 0 40px 0;\n    border-radius: 20px;\n    background-color: white;\n    border-radius: 20px;\n\n    & > p {\n      font-size: 20px;\n      font-weight: normal;\n      line-height: 1.5;\n      letter-spacing: -0.8px;\n      text-align: center;\n      color: ",
        ";\n      margin-bottom: 20px;\n    }\n\n    & > .button-wrap {\n      height: 50px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n      margin: 0 auto;\n\n      & > button {\n        height: 50px;\n        padding: 13px 30px;\n        font-size: 16px;\n        font-weight: bold;\n        letter-spacing: -0.64px;\n        text-align: center;\n        color: #ffffff;\n        border: 0;\n        border-radius: 8px;\n        cursor: pointer;\n\n        &.button-cancel {\n          min-width: 88px;\n          background-color: white;\n          border: solid 1px ",
        ";\n          color: #333;\n        }\n\n        &.button-confirm {\n          min-width: 88px;\n          background-color: ",
        ";\n        }\n      }\n    }\n  "
    ]);
    UserInfoExitModal_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserInfoExitModal_desktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    UserInfoExitModal_desktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var UserInfoExitModalDesktop = function(param) {
    var isOpen = param.isOpen, onClickCancel = param.onClickCancel, onClickConfirm = param.onClickConfirm;
    var addSignupModalCookie = (0,useSignupCookies/* default */.Z)().addSignupModalCookie;
    var handleClickConfirm = function() {
        onClickConfirm();
        addSignupModalCookie();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: isOpen,
        onClose: onClickCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfoExitModal_desktop_StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "입력된 내용은 저장되지 않습니다. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "종료하시겠습니까?"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "button-wrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "button-cancel",
                            onClick: onClickCancel,
                            children: "취소"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "button-confirm",
                            onClick: handleClickConfirm,
                            children: "종료"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var UserInfoExitModal_desktop = (UserInfoExitModalDesktop);
var UserInfoExitModal_desktop_StyledWrapper = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    displayName: "UserInfoExitModal.desktop__StyledWrapper",
    componentId: "sc-1c41aa5f-0"
})(UserInfoExitModal_desktop_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(UserInfoExitModal_desktop_templateObject(), theme.color.text_1, theme.line.line_2, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/userInfoModal/desktop/UserInfoModal.desktop.tsx






function UserInfoModal_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-height: 92vh;\n    overflow-y: auto;\n    ::-webkit-scrollbar {\n      display: block;\n    }\n    ::-webkit-scrollbar-track,\n    ::-webkit-scrollbar-button {\n      display: none;\n    }\n    ::-webkit-scrollbar-thumb {\n      border-radius: 15px;\n      background-color: ",
        ";\n    }\n    width: 502px;\n    padding: 25px 20px 40px;\n    border-radius: 15px;\n    background-color: white;\n\n    .join-container {\n      & > .divider {\n        border: none;\n        height: 1px;\n        background-color: ",
        ";\n        margin: 32px 0;\n      }\n      > .close-icon {\n        display: flex;\n        cursor: pointer;\n        flex-direction: row-reverse;\n      }\n      .join-title {\n        h2 {\n          text-align: center;\n          font-size: 20px;\n          font-weight: 500;\n          font-stretch: normal;\n          font-style: normal;\n          line-height: 1.4;\n          letter-spacing: -0.8px;\n          color: #333;\n          > span {\n            color: ",
        ";\n          }\n        }\n      }\n      .field-school-section {\n        margin-top: 24px;\n      }\n      .guide-section {\n        margin-top: 32px;\n      }\n      .modal-submit-button {\n        width: 120px;\n        margin: 0 auto;\n        padding-top: 8px;\n      }\n    }\n    p {\n      margin: 0 !important;\n    }\n    .pointer {\n      cursor: pointer;\n    }\n  "
    ]);
    UserInfoModal_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserInfoModal_desktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    UserInfoModal_desktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var UserInfoModal = function(param) {
    var isModalOpen = param.isModalOpen, handleModalClose = param.handleModalClose;
    var user = (0,useCurrentUser/* useCurrentUserContext */.O)().user;
    var reportToChatting = (0,ChattingContext/* useChattingContext */.Y)().reportToChatting;
    var getViewerData = (0,useGetPreviousUserInfo/* useGetPreviousUserInfo */.i)().getViewerData;
    var formMethods = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        resolver: (0,yup/* yupResolver */.X)(userInfoModalSchema/* default */.Z),
        defaultValues: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var viewerData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getViewerData()
                        ];
                    case 1:
                        viewerData = _state.sent();
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, viewerData), {
                                birthday: "",
                                phoneNumber: (user === null || user === void 0 ? void 0 : user.phoneNumber) || "",
                                subscribeSMS: false,
                                smsAuthedToken: ""
                            })
                        ];
                }
            });
        })
    });
    var handleSubmit = formMethods.handleSubmit;
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUpdateUserInitialInfoMutation */.AUb)({
        onCompleted: function() {
            reportToChatting({
                type: "reportChatRefreshMyChatRoom"
            });
            handleModalClose();
        },
        refetchQueries: [
            graphql/* GqlViewerHasAdditionalInfoFilledDocument */.WOE
        ]
    }), 1), updateUserInitialInfo = ref[0];
    var handleSubmitTest = function(data) {
        var ref;
        updateUserInitialInfo({
            variables: {
                input: {
                    education: {
                        finalEducationType: data.schoolType,
                        schoolName: data.school.name,
                        major: (ref = data.schoolMajor) === null || ref === void 0 ? void 0 : ref.name
                    },
                    birthday: (0,parse/* default */.Z)(data.birthday, "yyyyMMdd", new Date()).setHours(12),
                    phoneNumber: data.phoneNumber,
                    smsAuthedToken: data.smsAuthedToken,
                    preferJobCategoryIds: data.preferJobCategoryIds,
                    preferActivityTypes: data.preferActivityTypes.map(function(num) {
                        return Number(num);
                    }),
                    preferOrganizationIds: data.preferOrganizationIds,
                    subscribeSMS: data.subscribeSMS
                }
            }
        });
    };
    var ref1 = (0,react.useState)(false), isConfirmModalOpen = ref1[0], setIsConfirmModalOpen = ref1[1];
    var handleToggleConfirmModal = function() {
        setIsConfirmModalOpen(!isConfirmModalOpen);
    };
    var handleCloseAllModal = function() {
        setIsConfirmModalOpen(false);
        handleModalClose();
    };
    return /* TODO Type error: Type instantiation is excessively deep and possibly infinite. */ /* @ts-ignore  */ /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formMethods), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            open: isModalOpen,
            disableBackDropClose: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    onSubmit: handleSubmit(handleSubmitTest),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoModal_desktop_StyledWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            className: "join-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "close-icon",
                                    role: "button",
                                    onClick: handleToggleConfirmModal,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                        width: 16,
                                        height: 16,
                                        fill: "#333"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                    className: "join-title",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        children: [
                                            "정보를 입력하면 저희가",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "딱 맞는 커리어 정보"
                                            }),
                                            "를 알려드릴게요!"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupInterest/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    className: "field-school-section",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoModalInfo/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    className: "guide-section",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiveGuide_desktop, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    className: "modal-submit-button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupSubmitButton/* default */.Z, {
                                        buttonText: "선택 완료"
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoExitModal_desktop, {
                    isOpen: isConfirmModalOpen,
                    onClickCancel: handleToggleConfirmModal,
                    onClickConfirm: handleCloseAllModal
                })
            ]
        })
    }));
};
/* harmony default export */ var UserInfoModal_desktop = (UserInfoModal);
var UserInfoModal_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UserInfoModal.desktop__StyledWrapper",
    componentId: "sc-2becd40f-0"
})(UserInfoModal_desktop_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(UserInfoModal_desktop_templateObject(), theme.background.bg_1, theme.background.bg_1, theme.color.primary_2);
});


/***/ }),

/***/ 77278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useGetPreviousUserInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);




var useGetPreviousUserInfo = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlViewerPreferActivityTypesLazyQuery */ .fU6)(), 1), getViewerPreferActivityTypes = ref[0];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlViewerPreferOrganizationIdsLazyQuery */ .xOB)(), 1), getViewerPreferOrganizationIds = ref1[0];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlViewerJobCategoriesLazyQuery */ .Q54)(), 1), getViewerJobCategoriesData = ref2[0];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlViewerEducationLazyQuery */ .mY)(), 1), getViewerEducationData = ref3[0];
    var getViewerData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, preferActivityTypes, preferOrganizationIds, viewerJobCategoriesData, viewerEducationData, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            Promise.all([
                                getViewerPreferActivityTypes(),
                                getViewerPreferOrganizationIds(),
                                getViewerJobCategoriesData(),
                                getViewerEducationData()
                            ])
                        ];
                    case 1:
                        ref20 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            4
                        ]), preferActivityTypes = ref20[0], preferOrganizationIds = ref20[1], viewerJobCategoriesData = ref20[2], viewerEducationData = ref20[3];
                        return [
                            2,
                            {
                                preferActivityTypes: ((ref = preferActivityTypes.data) === null || ref === void 0 ? void 0 : (ref1 = ref.viewerPreferActivityTypes) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                    return item === null || item === void 0 ? void 0 : item.id;
                                })) || [],
                                preferOrganizationIds: ((ref2 = preferOrganizationIds.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.viewerPreferOrganizationIds) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
                                    return item === null || item === void 0 ? void 0 : item.id;
                                })) || undefined,
                                preferJobCategoryIds: ((ref4 = viewerJobCategoriesData.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.viewerJobCategories) === null || ref5 === void 0 ? void 0 : ref5.map(function(item) {
                                    return item === null || item === void 0 ? void 0 : item.id;
                                })) || [],
                                schoolType: ((ref6 = viewerEducationData.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.viewerEducation) === null || ref7 === void 0 ? void 0 : ref7.educationType) || "",
                                school: {
                                    id: ((ref8 = viewerEducationData.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.viewerEducation) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.school) === null || ref10 === void 0 ? void 0 : ref10.id) || "",
                                    name: ((ref11 = viewerEducationData.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.viewerEducation) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.school) === null || ref13 === void 0 ? void 0 : ref13.name) || ""
                                },
                                schoolMajor: {
                                    id: ((ref14 = viewerEducationData.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.viewerEducation) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.major) === null || ref16 === void 0 ? void 0 : ref16.id) || "",
                                    name: ((ref17 = viewerEducationData.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.viewerEducation) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.major) === null || ref19 === void 0 ? void 0 : ref19.name) || ""
                                }
                            }
                        ];
                    case 2:
                        err = _state.sent();
                        return [
                            2,
                            {
                                preferActivityTypes: [],
                                preferOrganizationIds: undefined,
                                preferJobCategoryIds: [],
                                schoolType: "",
                                school: {
                                    id: "",
                                    name: ""
                                }
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getViewerData() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        getViewerData: getViewerData
    };
};


/***/ }),

/***/ 82033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var date_fns_isValid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12274);
/* harmony import */ var date_fns_parseISO__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23855);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16310);
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35460);




var userInfoModalSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
    preferJobCategoryIds: yup__WEBPACK_IMPORTED_MODULE_0__/* .array */ .IX().of(yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_()).min(1),
    preferActivityTypes: yup__WEBPACK_IMPORTED_MODULE_0__/* .array */ .IX().of(yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx()).min(1),
    preferOrganizationIds: yup__WEBPACK_IMPORTED_MODULE_0__/* .array */ .IX().of(yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_()).nullable().test({
        name: "is-checked-recruit",
        test: function test(value) {
            var preferActivityTypes = this.parent.preferActivityTypes;
            if (preferActivityTypes && preferActivityTypes.includes(constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT)) {
                return (value !== null && value !== void 0 ? value : []).length >= 1;
            }
            return true;
        }
    }),
    schoolType: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(),
    school: yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
        id: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(),
        name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_()
    }),
    birthday: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().test({
        name: "is-only-number",
        test: function(birthday) {
            return !birthday || /^[0-9\\.]+$/g.test(birthday);
        },
        message: "생년월일 형식이 올바르지 않습니다"
    }).test({
        name: "is-valid-date",
        test: function(birthday) {
            var isEmpty = !birthday;
            if (isEmpty) {
                return true;
            }
            var birthdayISO = (0,date_fns_parseISO__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(birthday.replaceAll(".", "-"));
            var isFuture = birthdayISO > new Date();
            var isValidated = (birthday === null || birthday === void 0 ? void 0 : birthday.length) === 8 && (0,date_fns_isValid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(birthdayISO);
            if (!isFuture && isValidated) {
                return true;
            }
            return false;
        },
        message: "생년월일 형식이 올바르지 않습니다"
    }).required("생년월일을 입력해주세요"),
    subscribeSMS: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7(),
    phoneNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(),
    phoneInput: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().test({
        name: "phone-input",
        test: function test(inputValue) {
            var phoneNumber = this.parent.phoneNumber;
            if (phoneNumber || inputValue && inputValue.length >= 10) {
                return true;
            }
            return false;
        },
        message: "번호를 올바르게 입력해주세요"
    }),
    phoneVerification: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_()
});
/* harmony default export */ __webpack_exports__["Z"] = (userInfoModalSchema);


/***/ }),

/***/ 8316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _ActivityListCardItem__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _ActivityListCardItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70525);



/***/ }),

/***/ 36957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ getLimitNumText; }
/* harmony export */ });
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93293);

var getLimitNumText = function(param) {
    var number = param.number, limit = param.limit;
    if (number <= limit) {
        return (0,utils__WEBPACK_IMPORTED_MODULE_0__/* .numberWithCommas */ .x6)(number);
    } else {
        return "".concat((0,utils__WEBPACK_IMPORTED_MODULE_0__/* .numberWithCommas */ .x6)(limit), "+");
    }
};


/***/ }),

/***/ 58432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZQ": function() { return /* binding */ IOS_APP_VERSIONS; },
/* harmony export */   "hk": function() { return /* binding */ AOS_APP_VERSIONS; },
/* harmony export */   "sJ": function() { return /* binding */ VERIFIED_APP_VERSIONS; }
/* harmony export */ });
var VERIFIED_APP_VERSIONS = {
    CAREER_NAVER_LICENSE: "CAREER_NAVER_LICENSE",
    COVER_LETTER_AD_EDUCATION: "COVER_LETTER_AD_EDUCATION",
    SCRAP_USER_STATISTICS: "SCRAP_USER_STATISTICS",
    TEAM_RECRUIT: "TEAM_RECRUIT",
    COMPANY_INFO: "COMPANY_INFO"
};
var IOS_APP_VERSIONS = {
    CAREER_NAVER_LICENSE: "1.22.0",
    COVER_LETTER_AD_EDUCATION: "1.24.1",
    SCRAP_USER_STATISTICS: "1.29.0",
    TEAM_RECRUIT: "1.46.0",
    COMPANY_INFO: "2.1.0"
};
var AOS_APP_VERSIONS = {
    CAREER_NAVER_LICENSE: "1.22.0",
    COVER_LETTER_AD_EDUCATION: "1.24.1",
    SCRAP_USER_STATISTICS: "1.29.0",
    TEAM_RECRUIT: "1.46.0",
    COMPANY_INFO: "2.1.0"
};


/***/ })

}]);